import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../../../hive/ui/Icon';
import { FT_TABS, activeTab } from '../routes';
import { tr } from '../i18n';

/**
 * Bottom tab bar (spec § 4): Home, Suppliers, +Add, Shortlist, Follow-ups.
 * Hidden on the fairs hub and welcome (the caller decides, via `chrome`), and
 * replaced by the top nav at ≥860px via CSS.
 *
 * Hive's own BottomNav is already suppressed here — HiveShell hides it whenever
 * an app is open — so these two bars can never collide.
 */
export default function FairTabBar() {
  const location = useLocation();
  const active = activeTab(location.pathname);

  return (
    <nav className="ft-tabbar" aria-label="Fair Tracker sections">
      {FT_TABS.map((t) => {
        const on = active === t.key;
        return (
          <Link
            key={t.key}
            to={t.to}
            className={`ft-tab${on ? ' ft-tab-on' : ''}${t.accent ? ' ft-tab-add' : ''}`}
            aria-current={on ? 'page' : undefined}
          >
            {t.accent ? (
              <span className="ft-tab-badge" aria-hidden="true">
                +
              </span>
            ) : (
              <Icon name={t.icon} size={19} />
            )}
            <span>{tr(t.label)}</span>
          </Link>
        );
      })}
    </nav>
  );
}
